import _typeof from "/portal/Vue/node_modules/@babel/runtime-corejs2/helpers/typeof.js";
import _asyncToGenerator from "/portal/Vue/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/portal/Vue/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.freeze.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
/// ///////////////////////////////////////////////////////////////////////
//        Сервисные функции, реализующие общие операции с объектом
/// ///////////////////////////////////////////////////////////////////////

var MENU_FRESHADDLE_FRESH = 'com.act.menuFresh'; // 'Перейти к актуальным записям';
var MENU_FRESHADDLE_ADDLE = 'com.act.menuAddle'; // 'Перейти к удаленным записям';
var ICON_ORD_LEFT = 'keyboard_arrow_left';
var ICON_ORD_RIGHT = 'keyboard_arrow_right';
import Vue from 'vue';
import rowActionButton from 'components/RowActionButton';
export var MODE_STREAM = 1; // Потоковый ввод
export var MODE_INITAB = 2; // Инициализация таблицы (actSelect) при создании объекта
export var MODE_ENVRSE = 3; // Deprecated!

export var MODE = Object.freeze({
  Stream: 1,
  stream: 1,
  InitTab: 2,
  inittab: 2,
  initcard: 2,
  initCard: 2,
  EnvRse: 3,
  envrse: 3,
  envRse: 3,
  recpage: 4,
  recPage: 4,
  recread: 5,
  recRead: 5
});
export var CARD = Object.freeze({
  tab: 'cardTab',
  list: 'cardList',
  add: 'cardAdd',
  upd: 'cardUpdate',
  update: 'cardUpdate',
  view: 'cardView',
  rse: 'cardRse'
});
export var ENTRY = Object.freeze({
  cardTab: CARD.tab,
  cardList: CARD.list,
  cardAdd: CARD.add,
  cardUpd: CARD.upd,
  cardView: CARD.view
});
export var MESS = Object.freeze({
  Info: 1,
  info: 1,
  Warning: 2,
  warning: 2,
  Error: 3,
  error: 3,
  Confirm: 4,
  confirm: 4
});
export var CHK = Object.freeze({
  leave: 1,
  onclick: 2,
  debounce: 3,
  ok: 4,
  showmess: 5,
  correct: 6,
  exam: function exam(opts, opt) {
    for (var i = 0; i < opts.length; i++) {
      if (opts[i] === opt) {
        return true;
      }
    }
    return false;
  }
});
export default {
  props: {
    aftobjFrom: Object,
    aftobjMaster: Object
  },
  components: {
    rowActionButton: rowActionButton
  },
  data: function data() {
    return {
      aftobj: this,
      aftobjDetails: null,
      aftobjCode: '',
      aftobjAlias: null,
      aftobjName: '',
      aftobjTabName: '',
      aftobjEntry: ENTRY.cardTab,
      aftobjActs: [],
      // список экшенов, сформированный разработчиком в коде при описании объекта:
      //       {act, icon, lab, scope /* 'tab' 'row' 'tabrow' */, acs}
      aftobjMode: [],
      aftobjFk: null,
      // поле-Fk на объект-мастер
      aftlabCardTab: '',
      aftlabCardTabIni: '',
      // aftlabCardRec: '',
      aftlabCardList: '',
      aftcard: null,
      aftcardRem: null,
      aftfrmTable: !this.aftobjFrom,
      aftfrmRec: false,
      aftfrmRse: false,
      aftfrmList: false,
      aftobjRoutes: null,
      aftloading: false,
      aftselection: undefined,
      aftact: null,
      aftactRow: null,
      afthistRowClick: null,
      // Click on aftHistory table
      afthistRowDblClick: null,
      aftpagination: {
        sortBy: 'id',
        descending: false,
        page: 1,
        rowsPerPage: 0
      },
      aftord: null,
      aftenv: {
        // кешируемый контекст
        acts: [],
        // список доступных экшенов, формируется при инициализации объекта
        actsRow: [],
        // список экшенов для формирования меню для строки таблицы
        actsTab: [],
        // список экшенов для формирования меню для всей таблицы
        filter: '',
        data: [],
        menuFreshAddleCode: MENU_FRESHADDLE_ADDLE,
        selected: [],
        dblclickrow: null,
        recRse: null
      }
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // При миксировании в объекте описания объекта с aftmixin этот эвент вызовется дважды,
            // надо учитывать, что  this.aftobjDesc в одном из вызовов м.б. "undefined"

            if (typeof this.aftobjDesc !== 'undefined') {
              // Если определен aftobjDescr, все атрибуты и параметры берем из него, независимо от того пейдж какой карточки открывается
              Object.assign(this, this.aftobjDesc);

              // Если в параметрах маршрутизатора задана aftcard, устанавливаем ее в качестве текущей.
              if ('card' in this.$route.params) {
                this.aftcard = this.$route.params.card;
              }

              // Системная инициализация
              this.initObject();

              // Мастер - деталь
              if (typeof this.aftobjMaster !== 'undefined' && this.aftobjMaster) {
                if (!this.aftobjMaster.aftobjDetails) {
                  this.aftobjMaster.aftobjDetails = [];
                }
                this.aftobjMaster.aftobjDetails.push(this);
              }

              // Вызываем эвент объекта инициализации карточки
              if ('eventCapture' in this) {
                this.eventCapture('evnIniCard');
                this.eventCapture('evnInitCard');
              }
            } else {
              // Deprecated !!!
              //
              // Код ниже только для поддержки старого механизма имплементации aft в объекты
              //

              // Инициализация объекта
              if ('eventCapture' in this) {
                this.eventCapture('evnCreated');
              }
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  computed: {
    // ------------------------------------------------------------------------------------------------
    //                         aftCardLabel   aftCardTabLabel
    // Возвращают наименования (лабелы) форм карточек
    // ---
    //                        aftCardCaption
    // Возвращает кэпшен к наименованию формы карточки ("новая запись"/"редактирование"/"просмотр"...)
    // Для поддержки старого свойства
    aftlabCardRec: function aftlabCardRec() {
      return this.aftCardLabel + ' (' + this.aftCardCaption + ')';
    },
    aftMenuFreshAddle: function aftMenuFreshAddle() {
      return this.$t(this.aftenv.menuFreshAddleCode);
    },
    // Заголовок табличной карточки (~"Пользователи")
    aftCardTabLabel: function aftCardTabLabel() {
      if (this.$te(this.aftobjCode + '.lab.cardTab')) {
        return this.$t(this.aftobjCode + '.lab.cardTab');
      }
      var lab = this.aftobjName || this.aftobjCode;
      return lab;
    },
    // Заголовок карточки (~"Пользователь"/"Фильтр БД")
    aftCardLabel: function aftCardLabel() {
      var suf = this.aftcard;
      if (this.$te(this.aftobjCode + '.lab.' + suf)) {
        return this.$t(this.aftobjCode + '.lab.' + suf);
      } else {
        if (!this.isTabCard()) {
          return this.$t(this.aftobjCode + '.lab.cardRec');
        }
        return this.$t(this.aftobjCode + '.lab.cardTab');
      }
    },
    // Кэпшен карточки (новая запись/редактирование/просмотр...)
    aftCardCaption: function aftCardCaption() {
      var suf = this.aftcard;
      if (this.aftcard === CARD.rse && !this.is_mode_fresh()) {
        suf = suf + 'Addle';
      }
      return this.$t('com.lab.capt' + suf);
    },
    aftCardTabCaption: function aftCardTabCaption() {
      if (!this.is_mode_fresh()) {
        return this.$t('com.lab.captcardTabAddle');
      }
      if (this.aftcard === CARD.list) {
        return this.$t('com.lab.captList');
      }
      return null;
    }
  },
  methods: {
    is_mode_fresh: function is_mode_fresh() {
      return this.aftenv.menuFreshAddleCode === MENU_FRESHADDLE_ADDLE;
    },
    go_mode_fresh: function go_mode_fresh() {
      this.aftenv.menuFreshAddleCode = MENU_FRESHADDLE_ADDLE;
      this.recRse.Actual = 'Y';
    },
    go_mode_addle: function go_mode_addle() {
      this.aftenv.menuFreshAddleCode = MENU_FRESHADDLE_FRESH;
      this.recRse.Actual = 'N';
    },
    inMode: function inMode(mode) {
      for (var i = 0; i < this.aftobjMode.length; i++) {
        if (this.aftobjMode[i] === mode) {
          return true;
        }
      }
      return false;
    },
    isTabEntry: function isTabEntry() {
      return this.aftobjEntry === ENTRY.cardTab || this.aftobjEntry === ENTRY.cardList;
    },
    isTabCard: function isTabCard() {
      return this.aftcard === CARD.tab || this.aftcard === CARD.list;
    },
    isVUCard: function isVUCard() {
      return this.aftcard === CARD.view || this.aftcard === CARD.upd;
    },
    aftIsModeFresh: function aftIsModeFresh() {
      return this.is_mode_fresh();
    },
    aftStrIn: function aftStrIn(sub, str) {
      var arrstr = str.split(',');
      for (var i = 0; i < arrstr.length; i++) {
        if (arrstr[i] === sub) {
          return true;
        }
      }
      ;
      return false;
    },
    aftParseObjectField: function aftParseObjectField(fldname) {
      var retObj = {
        obj: this,
        fld: null
      };
      if (typeof fldname !== 'undefined' && fldname) {
        fldname.split('.').forEach(function (itm, idx, arr) {
          if (idx === arr.length - 1) {
            retObj.fld = itm;
          } else {
            retObj.obj = retObj.obj[itm];
          }
        });
      }
      return retObj;
    },
    aftSayPositive: function aftSayPositive(mess) {
      this.$aft.messagePositive(this, mess);
    },
    aftSayNegative: function aftSayNegative(mess) {
      this.$aft.messageNegative(this, mess);
    },
    aftServerError: function aftServerError(resp) {
      this.$aft.treateServerError(this, resp);
    },
    _sleep: function _sleep(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    aftDelayed: function aftDelayed(ms) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this._sleep(ms);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // ----------------------------------------------------------------------------
    //                                aftInitObject
    //  Depricated !!!!
    // ----------------------------------------------------------------------------
    aftInitObject: function aftInitObject(objcode, params) {
      this.aftobjCode = objcode;
      if (params) {
        if ('objMode' in params) {
          this.aftobjMode = params.objMode;
        }
        if ('objEntry' in params) {
          this.aftobjEntry = params.objEntry;
        }
        this.aftobjRoutes = params.objRoutes;
      }
      this.initObject();
    },
    initObject: function initObject(objcode) {
      if (typeof objcode !== 'undefined') {
        this.$aft.errFatal('Вместо функции: "initObject" используйте функцию: "aftInitObject(objcode, params)" или "objDesc" (см. acsaccount)');
      }
      this.$aft.objListOnInit.push(this);
      if (!this.aftobjTabName) {
        this.aftobjTabName = this.aftobjCode; // Используется в истории изменений
      }

      // Инициализация среды
      this.$aft.initObject(this);
      // Если в кэше удаленные записи, надо восстановить кэпшены
      if (!this.is_mode_fresh()) {
        this.go_mode_addle();
      }

      // Текущая карточка
      this.aftcard = this.aftcard || this.aftobjEntry;
      if ('recRse' in this && this.recRse) {
        this.recRse.Actual = 'Y';
      }
      ;

      // Для режима MODE.recpage, если точка входа cardTab или cardList, устанавливаем MODE.recread
      // Для режима MODE.initcard, если точка входа не табличная, устанавливаем MODE.recread
      if (this.inMode(MODE.recpage) && this.isTabEntry() || this.inMode(MODE.initcard) && !this.isTabEntry()) {
        this.aftobjMode.push(MODE.recread);
      }

      // Инициализация карточки-точки входа данными
      if (this.inMode(MODE.initCard)) {
        if (this.isTabCard() && !this.aftenv.data.length && !this.aftobjMaster) {
          // если это деталь, инициализация делается в tabSelect мастера
          this.aftAction('actSelect');
        }
        if (this.isVUCard()) {
          this.$aft.setRecContent(this);
        }
      }
      ;

      // Создаем баттоны сортировки
      if ('columns' in this) {
        for (var i = 0; i < this.columns.length; i++) {
          if ('aftord' in this.columns[i]) {
            if (!this.aftord) {
              this.aftord = {};
            }
            ;
            // this.aftord[this.columns[i].field] = {};
            Vue.set(this.aftord, this.columns[i].field, {});
            Vue.set(this.aftord[this.columns[i].field], 'iLeft', null);
            Vue.set(this.aftord[this.columns[i].field], 'iRight', null);
            Vue.set(this.aftord[this.columns[i].field], 'lLeft', null);
            Vue.set(this.aftord[this.columns[i].field], 'lRight', null);
            // console.log('this.aftord: ')
            // console.log(this.aftord)
            if (this.columns[i].aftord < 0) {
              this.aftord[this.columns[i].field].iLeft = null;
              this.aftord[this.columns[i].field].lLeft = this.columns[i].aftord * -1;
              this.aftord[this.columns[i].field].iRight = ICON_ORD_RIGHT;
              this.aftord[this.columns[i].field].lRight = null;
            } else {
              if (this.columns[i].aftord > 0) {
                this.aftord[this.columns[i].field].iLeft = ICON_ORD_LEFT;
                this.aftord[this.columns[i].field].lLeft = null;
                this.aftord[this.columns[i].field].iRight = null;
                this.aftord[this.columns[i].field].lRight = this.columns[i].aftord;
              } else {
                this.aftord[this.columns[i].field].iLeft = ICON_ORD_LEFT;
                this.aftord[this.columns[i].field].lLeft = null;
                this.aftord[this.columns[i].field].iRight = ICON_ORD_RIGHT;
                this.aftord[this.columns[i].field].lRight = null;
              }
            }
            ;
          }
        }
        ;
      }
      ;
    },
    aftGetEnumList: function aftGetEnumList(flddata, enumcode) {
      this.$aft.getEnumList(this, flddata, enumcode);
    },
    aftInitList: function aftInitList() {
      // Надо учитывать, что объект мог быть закэширован в режиме ADDLE.
      // В этом случае надо перейти в режим актуальных записей и сбросить кэш таблицы.
      if (!this.is_mode_fresh()) {
        this.go_mode_fresh();
        this.aftenv.data = [];
        if (this.inMode(MODE_INITAB)) {
          this.aftAction('actSelect');
        }
        ;
      }
      ;
      this.aftfrmTable = false;
      this.aftcardRem = this.aftcard;
      this.aftcard = 'cardList';
      this.aftfrmList = true;
      this.aftpagination.rowsPerPage = 10000;
    },
    // ------------------------------------------------------------------------------------------------
    //                                      aftActLabel
    //
    // Возвращает наименования кнопки стандартного/собственного экшена
    // ------------------------------------------------------------------------------------------------
    aftActLabel: function aftActLabel(actcode, oncard) {
      var lab,
        card = typeof oncard === 'undefined' ? this.aftcard : oncard;

      // if ( typeof(this.aftcard) === "undefined" || ! this.aftcard || this.aftcard === CARD.tab ) {
      //   return null
      // }

      // Отдельно для actOk, actCancel
      if (actcode === 'actOk') {
        lab = card === CARD.add || card === CARD.upd ? 'save' : card === CARD.rse ? 'select' : 'choice';
        return this.$t('com.act.' + lab);
      }
      if (actcode === 'actCancel') {
        lab = card === 'cardView' ? 'return' : 'cancel';
        return this.$t('com.act.' + lab);
      }
      if (actcode === 'actCancel') {
        lab = card === 'cardView' ? 'return' : 'cancel';
        return this.$t('com.act.' + lab);
      }

      // Отдельно для actFreshAddleA и actSwitchMarksOn
      if (actcode === 'actFreshAddle') {
        lab = this.aftIsModeFresh() ? 'actFreshAddleA' : 'actFreshAddleF';
        return this.$t('com.act.' + lab);
      }
      if (actcode === 'actSwitchMarks') {
        lab = typeof this.aftselection === 'undefined' ? 'actSwitchMarksOn' : 'actSwitchMarksOff';
        return this.$t('com.act.' + lab);
      }

      // Если есть список экшенов от разработчика
      if (this.aftobjActs.length) {
        for (var i = 0; i < this.aftobjActs.length; i++) {
          if (actcode === this.aftobjActs[i].act && this.aftobjActs[i].lab) {
            return this.aftobjActs[i].lab;
          }
        }
      }

      // То, что в базе
      for (var _i = 0; _i < this.aftenv.acts.length; _i++) {
        if (this.aftenv.acts[_i].code === actcode && this.aftenv.acts[_i].labcode) {
          return this.$t(this.aftenv.acts[_i].labcode);
        }
      }
      // Из стандартных
      if (this.$te('com.act.' + actcode)) {
        return this.$t('com.act.' + actcode);
      }
      // По имени объекта
      return this.$t(this.aftobjCode + '.act.' + actcode);
    },
    // ------------------------------------------------------------------------------------------------
    //                                      aftActIcon
    //
    // Возвращает иконку кнопки стандартного/собственного экшена
    // ------------------------------------------------------------------------------------------------
    aftActIcon: function aftActIcon(actcode) {
      // Если есть список экшенов от разработчика
      if (this.aftobjActs.length) {
        for (var i = 0; i < this.aftobjActs.length; i++) {
          if (actcode === this.aftobjActs[i].act && this.aftobjActs[i].icon) {
            return this.aftobjActs[i].icon;
          }
        }
      }
      // То, что в базе
      for (var _i2 = 0; _i2 < this.aftenv.acts.length; _i2++) {
        if (this.aftenv.acts[_i2].code === actcode) {
          return this.aftenv.acts[_i2].icon;
        }
      }
      return null;
    },
    // ---------------------------------------------------------------------------------------
    //                aftCardVoid aftRseCardVoid aftRseCardIcon aftRseCardIconClear
    // ---------------------------------------------------------------------------------------
    // Если в rec есть заполненные поля - true
    // Поле 'Actual' из проверки исключается
    aftCardVoid: function aftCardVoid(acard) {
      var card = typeof acard === 'undefined' || !acard ? this.aftcard : acard;
      var rec = card === CARD.rse ? this.recRse : this.recAdd;
      if (card === CARD.rse && !('recRse' in this)) return true;
      for (var fld in rec) {
        if (fld !== 'Actual' && rec[fld]) {
          return false;
        }
      }
      return true;
    },
    aftRseCardVoid: function aftRseCardVoid() {
      return this.aftCardVoid(CARD.rse);
    },
    // Иконка для кнопки Фильтр БД на панели инструментов табличной карточки
    aftRseCardIcon: function aftRseCardIcon() {
      // let icon = this.aftRseCardVoid() ? "img:statics/icons/filter-outline_blue.png" : "img:statics/icons/filter-outline_red.png"
      var icon = 'img:statics/icons/filter-outline_blue.png';
      return icon;
    },
    // Иконка для кнопки Сброс фильтра БД на панели инструментов табличной карточки
    aftRseCardIconClear: function aftRseCardIconClear() {
      return 'img:statics/icons/filter-remove-outline.png';
      // return "img:statics/icons/filter-remove-outline_blue.png"
    },
    // ----------------------------------------------------------------------------
    //                                aftLicence
    // ----------------------------------------------------------------------------
    aftLicence: function aftLicence(act, row) {
      // При создании объекта в какой-то момент this.aftenv.acts == null, чтобы не ломилось:
      if (!this.aftenv.acts) {
        return true;
      }

      // В режиме "протухших" записей разрешаем немногое (отсекая в том числе и все собственные зарегистрированные действия)
      if (!this.is_mode_fresh() && !this.aftStrIn(act, 'actSelect,actView,actDeleteP,actRepairAddle,actFreshAddle,actHistory,actExcel,actSwitchMarks')) {
        return false;
      }
      ;
      // В режиме "хороших" записей отсекаем действия предназначенные для "тухлых"
      if (this.is_mode_fresh() && this.aftStrIn(act, 'actDeleteP,actRepairAddle')) {
        return false;
      }
      ;
      // Отсекаем заведомо невыполнимые действия (например, нет помеченных для удаления)
      if (
      // ('actView,actUpdate,actDelete,actDeleteP,actRepairAddle'.indexOf(act) !== -1 && !this.aftenv.selected.length) ||
      this.aftloading || act === 'actDeleteP' && this.is_mode_fresh() || (act === 'actOk' || act === 'actClearRec') && this.aftcard === 'cardView' || act === 'actOk' && this.aftcard === 'cardList' && !this.aftenv.selected.length ||
      // ((act === 'actHistory') && this.aftcard !== 'cardView') ||
      this.aftStrIn(act, 'actDeleteM,actDeleteP,actRepairAddle') && !this.aftenv.selected.length || (act === 'actView' || act === 'actUpdate' || act === 'actAdd') && this.aftenv.selected.length > 1 || act === 'actExcel' && !this.aftenv.data.length || act === 'actReturn' && this.aftobjEntry === ENTRY.cardAdd) {
        return false;
      }
      // Вызов ownLicence
      if ('ownLicence' in this && !this.ownLicence(act, row)) {
        return false;
      }
      // Для 'actClearRec' & 'actClearRse' проверяем заполненость полей соотв-й карточки
      if (act === 'actClearRec') {
        return !this.aftCardVoid();
      }
      if (act === 'actClearRse') {
        return !this.aftRseCardVoid();
      }
      // Для некоторых экшенов доступом не управляем, просто - можно
      if (this.aftStrIn(act, 'actCan,actCancel,actReturn,actFilter,actFind,actSwitchMarks')) {
        return true;
      }
      return this.aftActEnable(act);
    },
    // Функция, управляющая видимостью экшена в меню
    aftVisibility: function aftVisibility(act, row) {
      if (act === 'actDeleteP' && this.is_mode_fresh() || act === 'actRepairAddle' && this.is_mode_fresh() || act === 'actDeleteM' && !this.is_mode_fresh()) {
        return false;
      }
      if ('ownVisibility' in this && !ownVisibility(act, row)) {
        return false;
      }
      return true;
    },
    // Проверка на присутствие экшена в списке доступных
    aftActEnable: function aftActEnable(act) {
      for (var i = 0; i < this.aftenv.acts.length; i++) {
        if (this.aftenv.acts[i].code === act) {
          return true;
        }
      }
      // Экшен м.б. определена Разработчиком как "всегда доступная":
      //      1. Экшен занесена в список как строка
      //      2. Экшен занесена в список как объект описания и у него отсутствует атрибут "acs"
      if (this.aftobjActs.length) {
        for (var _i3 = 0; _i3 < this.aftobjActs.length; _i3++) {
          if (_typeof(this.aftobjActs[_i3]) === 'object') {
            if (this.aftobjActs[_i3].act === act && typeof this.aftobjActs[_i3].acs === 'undefined') {
              return true;
            }
          } else {
            if (this.aftobjActs[_i3] === act) {
              return true;
            }
          }
        }
      }
      return false;
    },
    aftObjectAccess: function aftObjectAccess(objcode) {
      return true;
    },
    deleteOk: function deleteOk(act) {
      this.$aft.standartAction(this, act);
    },
    deleteCan: function deleteCan() {
      this.aftloading = false;
    },
    aftExitDialog: function aftExitDialog() {
      this.aftcard = this.aftcardRem;
    },
    // ----------------------------------------------------------------------------
    //                                aftAction
    // ----------------------------------------------------------------------------
    aftAction: function aftAction(act, row, fldname) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var suf, chkok, h, actionOrd;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              actionOrd = function _actionOrd(aftord, fldname, suf) {
                var ordlab = aftord[fldname]['l' + suf];
                var sufd = suf === 'Left' ? 'Right' : 'Left';
                //  console.log('fldname: ' + fldname + '  suf: ' + suf + '  ordlab1: ' + ordlab);
                if (ordlab) {
                  // Нажата кнопка с цифрой => убираем цифру, возвращаем иконку, уменьшаем на 1 другие заданные порядки
                  aftord[fldname]['l' + suf] = null;
                  aftord[fldname]['i' + suf] = suf === 'Left' ? ICON_ORD_LEFT : ICON_ORD_RIGHT;
                  for (var f in aftord) {
                    if (parseInt(aftord[f].lLeft) > parseInt(ordlab)) {
                      aftord[f].lLeft = String(parseInt(aftord[f].lLeft) - 1);
                    }
                    ;
                    if (parseInt(aftord[f].lRight) > parseInt(ordlab)) {
                      aftord[f].lRight = String(parseInt(aftord[f].lRight) - 1);
                    }
                    ;
                  }
                } else {
                  ordlab = aftord[fldname]['l' + sufd];
                  // console.log('fldname: ' + fldname + '  suf: ' + suf + '  ordlab2: ' + ordlab);
                  if (ordlab) {
                    // Нажата кнопка соседняя с кнопкой, у которой задан порядок
                    aftord[fldname]['l' + suf] = ordlab;
                    aftord[fldname]['i' + suf] = null;
                    aftord[fldname]['l' + sufd] = null;
                    aftord[fldname]['i' + sufd] = suf === 'Left' ? ICON_ORD_RIGHT : ICON_ORD_LEFT;
                  } else {
                    // Нажата кнопка у пары с иконками (порядок не задан) => вычисляем максим.порядок
                    var maxord = 0;
                    for (var _f in aftord) {
                      if (aftord[_f].lLeft && parseInt(aftord[_f].lLeft) > maxord) {
                        maxord = parseInt(aftord[_f].lLeft);
                      }
                      ;
                      if (aftord[_f].lRight && parseInt(aftord[_f].lRight) > maxord) {
                        maxord = parseInt(aftord[_f].lRight);
                      }
                      ;
                    }
                    aftord[fldname]['i' + suf] = null;
                    aftord[fldname]['l' + suf] = String(maxord + 1);
                  }
                }
              };
              suf = null;
              chkok = true; // console.log('aftaction act: ' + act);
              // console.log(row)
              if (!_this2.aftloading) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return");
            case 5:
              _this2.aftact = act;
              _this2.aftactRow = row;
              if (row) {
                _this2.aftenv.clickrow = row;
              }

              // Устанавливаем флажок "Выполнение", блокирующий все экшены
              // Для экшена act, требующего асинхронной обработки в $aft, флажок сбрасывается там. Иначе - тут.
              _this2.aftloading = true;
              _context3.t0 = 'eventCapture' in _this2;
              if (!_context3.t0) {
                _context3.next = 14;
                break;
              }
              _context3.next = 13;
              return _this2.eventCapture('evnBeforeAction', act);
            case 13:
              _context3.t0 = !_context3.sent;
            case 14:
              if (!_context3.t0) {
                _context3.next = 17;
                break;
              }
              _this2.aftloading = false;
              return _context3.abrupt("return");
            case 17:
              ;
              _context3.t1 = act;
              _context3.next = _context3.t1 === 'actFilter' ? 21 : _context3.t1 === 'actSwitchMarks' ? 26 : _context3.t1 === 'actFreshAddle' ? 29 : _context3.t1 === 'actSelect' ? 35 : _context3.t1 === 'actRepairAddle' ? 36 : _context3.t1 === 'actAdd' ? 38 : _context3.t1 === 'actUpdate' ? 42 : _context3.t1 === 'actView' ? 46 : _context3.t1 === 'actList' ? 50 : _context3.t1 === 'actOk' ? 53 : _context3.t1 === 'actChoice' ? 64 : _context3.t1 === 'actReturn' ? 66 : _context3.t1 === 'actDelete' ? 69 : _context3.t1 === 'actDeleteM' ? 69 : _context3.t1 === 'actDeleteP' ? 69 : _context3.t1 === 'actClearRec' ? 71 : _context3.t1 === 'actClearRse' ? 71 : _context3.t1 === 'actUpdateField' ? 74 : _context3.t1 === 'actHistory' ? 77 : _context3.t1 === 'actOrdLeft' ? 82 : _context3.t1 === 'actOrdRight' ? 82 : _context3.t1 === 'actExcel' ? 86 : 87;
              break;
            case 21:
              _this2.aftcardRem = _this2.aftcard;
              _this2.aftcard = CARD.rse;
              _this2.aftfrmRse = true;
              _this2.aftloading = false;
              return _context3.abrupt("break", 90);
            case 26:
              if (typeof _this2.aftselection === 'undefined') {
                _this2.aftselection = 'multiple';
              } else {
                _this2.aftselection = undefined;
                _this2.aftenv.selected = [];
              }
              _this2.aftloading = false;
              return _context3.abrupt("break", 90);
            case 29:
              if (_this2.is_mode_fresh()) {
                // Переходим в режим удаленных записей
                _this2.go_mode_addle();
              } else {
                // Переходим в режим актуальных записей
                _this2.go_mode_fresh();
              }
              ;
              // Генерим внешнее событие (пример использования - BranchSelector)
              _this2.$root.$emit('actFreshAddle', _this2.is_mode_fresh() ? 'FRESH' : 'ADDLE');
              _this2.data = [];
              _this2.$aft.standartAction(_this2, act, row, fldname);
              return _context3.abrupt("break", 90);
            case 35:
              return _context3.abrupt("return", _this2.$aft.standartAction(_this2, act, row, fldname));
            case 36:
              _this2.$aft.standartAction(_this2, act, row, fldname);
              return _context3.abrupt("break", 90);
            case 38:
              _this2.aftcard = 'cardAdd';
              // this.aftlabCardRec = this.aftobjName + this.$t('com.lab.addrec')
              _this2.$aft.standartAction(_this2, act, row, fldname);
              _this2.aftloading = false;
              return _context3.abrupt("break", 90);
            case 42:
              // Проверка на переустановку aftcard = cardView делается в $aft.setRecContent
              // this.aftloading = false  // сбросим флажок для корректной отработки aftLicence('actUpdate')
              // if ( !this.aftLicence('actUpdate',row) ) {
              //   this.aftAction('actView',row)
              //   return
              // }
              _this2.aftcard = 'cardUpdate';
              // this.aftlabCardRec = this.aftobjName + this.$t('com.lab.updrec')
              _this2.$aft.standartAction(_this2, act, row, fldname);
              _this2.aftloading = false;
              return _context3.abrupt("break", 90);
            case 46:
              _this2.aftcard = 'cardView';
              // this.aftlabCardRec = this.aftobjName + this.$t('com.lab.viewrec')
              _this2.$aft.standartAction(_this2, act, row, fldname);
              _this2.aftloading = false;
              return _context3.abrupt("break", 90);
            case 50:
              _this2.$refs[fldname].aftInitList();
              _this2.aftloading = false;
              return _context3.abrupt("break", 90);
            case 53:
              // alert('Action Ok')
              if ((_this2.aftcard === 'cardAdd' || _this2.aftcard === 'cardUpdate') && 'aftchkFuncs' in _this2) {
                chkok = _this2.$aft.recValid(_this2, _this2.aftchkFuncs);
              }
              ;
              if (_this2.aftcard === 'cardList' && 'eventCapture' in _this2.aftobjFrom) {
                chkok = _this2.aftobjFrom.eventCapture('evnChoice', _this2);
              }
              ;
              if (!chkok) {
                _context3.next = 61;
                break;
              }
              _this2.$aft.standartAction(_this2, act, row, fldname);
              _context3.next = 63;
              break;
            case 61:
              _this2.aftloading = false;
              return _context3.abrupt("return");
            case 63:
              return _context3.abrupt("break", 90);
            case 64:
              _this2.$aft.choiceAction(_this2, row);
              return _context3.abrupt("break", 90);
            case 66:
              _this2.$aft.standartAction(_this2, act, row, fldname);
              _this2.aftloading = false;
              return _context3.abrupt("break", 90);
            case 69:
              if (!_this2.aftConfirm(_this2.$t('com.msg.confirmDelete'), _this2.deleteOk, _this2.deleteCan, act)) {
                // Сюда попадаем, если на форме нет компоненты aftMessage
                _this2.deleteOk(act);
              }
              return _context3.abrupt("break", 90);
            case 71:
              _this2.$aft.standartAction(_this2, act, row, fldname);
              _this2.aftloading = false;
              return _context3.abrupt("break", 90);
            case 74:
              if (!_this2.aftLicence('actUpdate', row)) {
                _this2.$aft.messageNegative('Редактирование объекта запрещено');
              }
              _this2.$aft.standartAction(_this2, act, row, fldname);
              return _context3.abrupt("break", 90);
            case 77:
              h = _this2.$refs.AFTHistory || _this2.$refs.aftHistory || _this2.$refs.afthistory;
              if (typeof h !== 'undefined' && h) {
                h.row = row;
                h.init();
              }
              ;
              _this2.aftloading = false; // ???
              return _context3.abrupt("break", 90);
            case 82:
              suf = act === 'actOrdLeft' ? 'Left' : 'Right';
              actionOrd(_this2.aftord, fldname, suf);
              _this2.aftloading = false;
              return _context3.abrupt("break", 90);
            case 86:
              _this2.$aft.standartAction(_this2, act, row, fldname);
            case 87:
              _this2.aftloading = false; // Обработчики специальных экшенов сами управляют флажком
              if ('ownAction' in _this2) {
                _this2.ownAction(act, row);
              }
              ;
            case 90:
              if (!('eventCapture' in _this2 && !_this2.eventCapture('evnAfterAction', act))) {
                _context3.next = 92;
                break;
              }
              return _context3.abrupt("return");
            case 92:
              ;
              if (act === 'actOk') {
                if (_this2.aftcard === 'cardAdd' && _this2.inMode(MODE_STREAM)) {
                  // Потоковый ввод.
                  _this2.$aft.messagePositive(_this2, 'Сохранено');
                }
                // this.aftfrmRec = false ! так нельзя, закрывать надо в aft только при удачном завершении запроса к БД
                if (_this2.aftcard === 'cardRse') {
                  _this2.aftfrmRse = false;
                }
              }
              //   Заготовка для работы по внутренней настройке маршрутов внутри объекта
              //   ... пока такая потребность совсем не очевидна
              //
              //   // В завершении попатаемся перейти на нужный маршрут
              //   // Маршрут для actOk выполняется в $aft.recOk, здесь его делать нельзя, так как операция с БД асинхронная
              // else {
              //   this.$aft.gotoRoute(this,act)
              // }

              // --------------------------------------------------
              // Обрабатывает кнопки сортировки для карточки фильтра
              // --------------------------------------------------

              ;
            case 95:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // aftaction
    // ----------------------------------------------------------------------------
    //                                 checkRecValid
    // ----------------------------------------------------------------------------
    checkRecValid: function checkRecValid() {
      return this.$aft.recValid(this, this.aftchkFuncs);
    },
    // ----------------------------------------------------------------------------
    //                                 loadFk
    // ----------------------------------------------------------------------------
    loadFk: function loadFk(row) {
      if ('aftobjFk' in this) {
        this.recRse[this.aftobjFk] = row.id;
        return true;
      }
      return false;
    },
    // ----------------------------------------------------------------------------
    //                                aftTabRowClick
    // ----------------------------------------------------------------------------
    aftTabRowClick: function aftTabRowClick(evt, row) {
      this.aftenv.clickrow = row;
      if (this.aftloading) {
        return;
      }
      if ('eventCapture' in this) {
        if (!this.eventCapture('evnBeforeRowClick', row)) {
          return;
        }
      }
      // console.log('aftTabRowClick evt:')
      // console.log(evt)

      // Мастер - деталь
      //      ... включается только если помечена одна запись и при этом она !== row
      //
      // Если есть объекты-детали:
      //      ... помечаем текущую запись в текущем объекте (если уже помечена, не сбрасываем!)
      //      Для всех деталей:
      //      ... заполняем fk в cardRse
      //      ... вызываем evnBeforeDetailRenew
      //      ... активируем actSelect
      //      ... вызываем evnAfterDetailRenew

      if (this.aftobjDetails) {
        if (!this.aftenv.selected || !this.aftenv.selected.length || this.aftenv.selected.length === 1 && this.aftenv.selected[0] !== row) {
          this.aftenv.selected = [];
          this.aftenv.selected.push(row);
          for (var i = 0; i < this.aftobjDetails.length; i++) {
            var dtl = this.aftobjDetails[i];
            var fk = dtl.loadFk(row);
            var evnres = true;
            // evnBeforeDetailRenew + actSelect + evnAfterDetailRenew, но только если установлен Fk
            if (fk) {
              if ('eventCapture' in dtl) {
                evnres = dtl.eventCapture('evnBeforeDetailRenew', row);
              }
              if (evnres) {
                this.aftloading = true;
                dtl.aftAction('actSelect');
                if ('eventCapture' in dtl) {
                  dtl.eventCapture('evnAfterDetailRenew', row);
                }
              }
            }
          }
        }
      }
      if ('eventCapture' in this) {
        this.eventCapture('evnAfterRowClick', row);
      }
    },
    // ----------------------------------------------------------------------------
    //                                aftTabRowDblClick
    // ----------------------------------------------------------------------------
    aftTabRowDblClick: function aftTabRowDblClick(evt, row) {
      if ('eventCapture' in this) {
        if (!this.eventCapture('evnDblRowClick', row)) {
          return;
        }
      }
      // console.log('aftTabDblRowClick evt:')
      // console.log(evt)

      // Пометим запись, в которую тыкнули

      // Через стандартный механизм не очень красиво
      // this.aftenv.selected = []
      // for (let i = 0; i < this.aftenv.selected.length; i++) {
      //   if (this.aftenv.selected[i] === row) {
      //     this.aftenv.selected.splice(i, 1)
      //     return
      //   }
      // }
      // this.aftenv.selected.push(row)

      this.aftenv.dblclickrow = row;
      if (this.aftobjEntry === ENTRY.cardTab) {
        this.aftAction('actView', row);
      } else {
        this.aftAction('actChoice', row);
      }
    },
    aftDBAction: function aftDBAction(objcode, act, data, resfld, axiosConfig) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", _this3.$aft.dbAction(_this3, objcode, act, data, resfld, axiosConfig));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    aftReport: function aftReport(repcode, repName, data) {
      return this.$aft.Report(repcode, repName, data);
    },
    aftStatistic: function aftStatistic(repcode, data) {
      return this.$aft.Statistic(repcode, data);
    },
    aftGetSelectedString: function aftGetSelectedString() {
      return this.aftenv.selected.length === 0 ? '' : "".concat(this.aftenv.selected.length, " record").concat(this.aftenv.selected.length > 1 ? 's' : '', " selected of ").concat(this.aftenv.data.length);
    },
    aftShowCard: function aftShowCard() {
      // if ('recAdd' in this) {
      //   for(var key in this.recAdd) {
      //     if ( key in this.$refs && 'readonly' in this.$refs[key]) {
      //       // console.log('this.$refs[key].readonly/key:' + key);
      //       this.$refs[key].readonly = true;
      //     }
      //   };
      // };
    },
    aftMessage: function aftMessage(mtype, mtext, actfun, param) {
      var dial = this.$refs.AFTMessage || this.$refs.aftMessage;
      if (dial) {
        dial.messType = mtype || MESS.Error;
        dial.messText = mtext || this.afterrText;
        dial.funOk = actfun;
        dial.param = param;
        switch (dial.messType) {
          case MESS.Info:
            dial.messLab = this.$t('com.lab.messinfo');
            break;
          case MESS.Error:
            dial.messLab = this.$t('com.lab.messerr');
            break;
          case MESS.Confirm:
            dial.messLab = this.$t('com.lab.messconf');
            break;
        }
        dial.toshow = true;
        return true;
      }
      return false;
    },
    aftError: function aftError(errtext) {
      if (!this.aftMessage(MESS.error, errtext)) {
        this.$aft.messageNegative(this, errtext);
      }
    },
    aftConfirm: function aftConfirm(mtext, funOk, funCan, param) {
      var dial = this.$refs.AFTMessage || this.$refs.aftMessage;
      if (dial) {
        dial.messType = MESS.confirm;
        dial.messText = mtext;
        dial.funOk = funOk;
        dial.funCan = funCan;
        dial.param = param;
        dial.messLab = this.$t('com.lab.messinfo');
        dial.toshow = true;
        return true;
      }
      return false;
    },
    // вернуться к предыдущей странице браузера или совсем закрыть страницу
    goBackOrClose: function goBackOrClose() {
      if (window.history.length === 1) {
        // если страница в браузере открыта из email и в браузере еще сохранились куки авторизации
        window.close(); // закрыть вкладку браузера
      } else {
        this.$router.go(-1);
      }
    },
    goHome: function goHome() {
      // this.$router.push('/auth')
      this.$router.push({
        name: 'home'
      });
    }
  } // methods
};